import { useQuery } from '@tanstack/react-query';
import { getHolidayList } from '@entities/holiday/api/holiday';

/**
 * 공휴일 목록 조회 Hook
 * @param {number} year - 조회할 연도
 */
export function useHolidayListQuery(year) {
  return useQuery({
    queryKey: ['holidays', year],
    queryFn: () => getHolidayList(year),
    enabled: !!year, // year 없으면 실행 안함
    staleTime: 1000 * 60 * 60, // 1시간 캐싱
    gcTime: 1000 * 60 * 60 * 24, // 24시간 메모리 유지 (선택)
  });
}
